import React from "react";
import PromotingEventsList from "./PromotingEventsList";

const MyPromotingEvents = () => {
  return <PromotingEventsList />;
};

export default MyPromotingEvents;
